<template>
  <Modal v-model="viewSpecificationsModal" :title="viewSpecificationsTitle" width="825" :transfer="false">
    <template v-if="viewSpecificationType === 'businessLicense'">
      <h2 class="title font-size-14 font-weight-bold color-333">{{ $t('key1006482') }}</h2>
      <p class="mt10 mb30 font-size-12">
        1. {{ $t('key1006483') }}<br/>
        2. {{ $t('key1006484') }}<br/>
        3. {{ $t('key1006485') }}<br/>
      </p>
      <h3 class="font-size-17 font-weight-bold mb10 color-333">{{ $t('key1006486') }}</h3>
      <img :src="businessLicenseImg" width="793" height=462 :alt="$t('key1002751')">
    </template>
    <template v-if="viewSpecificationType === 'legalRepresentative'">
      <h2 class="title font-size-14 font-weight-bold color-333">{{ $t('key1006487') }}</h2>
      <p class="mt10 mb30 font-size-12">
        1. {{ $t('key1006488') }}<br/>
        2. {{ $t('key1006489') }}<br/>
      </p>
      <h3 class="font-size-17 font-weight-bold mb10 color-333">{{ $t('key1006486') }}</h3>
      <img :src="legalRepresentativeImg" width="793" height=442 :alt="$t('key1002751')">
    </template>
    <template #footer>
      <Button type="primary" @click="viewSpecificationsModal = false">{{ $t('key1000732') }}</Button>
    </template>
  </Modal>
</template>

<script>
import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "viewSpecificationsModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      viewSpecificationsModal: false,
      viewSpecificationsTitle: '',
      viewSpecificationType: null,
      businessLicenseImg: require('@/assets/images/supplier_businessLicense.png'),
      legalRepresentativeImg: require('@/assets/images/supplier_legalRepresentative.png'),
    };
  },
  created() {

  },
  methods: {
    // 初始化数据
    initViewSpecificationsData(type, title) {
      this.viewSpecificationType = type;
      this.viewSpecificationsTitle = title;
      this.viewSpecificationsModal = true;
    }
  }
};
</script>

<style lang="less" scoped>

</style>